import { observer } from "mobx-react";
import { NotificationPivotMenu } from "../../ui/molecules/notification-pivot-menu";
import React from "react";
import { store } from "../../store";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../components/ui/sheet";
import { useTranslation } from "react-i18next";

export type NotificationsProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export const Notifications = observer(({ open, onOpenChange }: NotificationsProps): JSX.Element => {
    const { t } = useTranslation();

    const notifications = Array.from(store.repositoryPersistentNotifications.entities.values());
    notifications.sort((a, b) => b.triggeredAt.getTime() - a.triggeredAt.getTime());

    const markNotificationRead = async (id: string): Promise<void> => {
        await store.repositoryPersistentNotifications.update(id, { read: true });
    };

    const markAllNotificationsRead = async (): Promise<void> => {
        for (const [key, value] of store.repositoryPersistentNotifications.entities) {
            if (!value.read) {
                await markNotificationRead(key);
            }
        }
    };

    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            {/* Preflight required for portal view to be styled correctly */}
            <SheetContent className="preflight overflow-auto">
                <SheetHeader className="pb-4">
                    <SheetTitle>{t("component.sidebarNavigation.notifications")}</SheetTitle>
                </SheetHeader>
                <NotificationPivotMenu
                    notifications={notifications}
                    markNotificationRead={markNotificationRead}
                    onClick={markAllNotificationsRead}
                />
            </SheetContent>
        </Sheet>
    );
});
